import { api } from "constants/RotasAPI";
import { LoadingContext } from "context/LoadingContext";
import { UserContext } from "context/UserContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { http } from "shared/util/http";
import IntegracaoV1, { RedirectToV1Options } from "shared/util/integrarFrontEndV1Functions";
import { queryClient } from "shared/util/queryClient";
import { CondominioContextoDTO } from "types/dto/CondominioContextoDTO";
import { TokenDTO } from "types/dto/TokenDTO";

const usePostAlterarCondominioContextoToken = () => {
  const { redirectToV1 } = IntegracaoV1();
  const { alteraUsuarioContexto, alterarCondominioContexto } = useContext(UserContext);
  const { setLoading } = useContext(LoadingContext);

  const alterarCondominioContextoToken = async (
    condominioId: number,
    redirectPath: string = "/",
    redirectOptions?: RedirectToV1Options
  ) => {
    setLoading(true);
    await http
      .post<TokenDTO>(`${api.condominio.postAlterarCondominioContextoToken}/${condominioId}`)
      .then(async (response) => {
        localStorage.setItem("jhi-authenticationToken", response.data.token);
        alteraUsuarioContexto();

        const condominioEmCache = queryClient.getQueryData([
          "user-context",
          condominioId.toString(),
        ]) as CondominioContextoDTO;

        if (condominioEmCache && condominioEmCache.id === condominioId) {
          alterarCondominioContexto(condominioEmCache);
        }
        redirectToV1(redirectPath, redirectOptions);
      })
      .catch((error) => {
        toast.error("Erro ao alterar condominio contexto");
      })
      .finally(() => setLoading(false));
  };

  return { alterarCondominioContextoToken };
};

export default usePostAlterarCondominioContextoToken;
